import { IFinancialStatus } from "@domain/version2/FinancialStauts"
import apiClient from "@util/ApiClient"
import { AxiosResponse } from "axios"

export default class FinancialStatusApi {
    static getFinancialStatus(): Promise<AxiosResponse<IFinancialStatus[]>> {
        return apiClient.get("financial-statuses")
    }
}
